import { render, staticRenderFns } from "./fixedPriceData.vue?vue&type=template&id=4ab1cce1&scoped=true"
import script from "./fixedPriceData.vue?vue&type=script&lang=ts"
export * from "./fixedPriceData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1cce1",
  null
  
)

export default component.exports